import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { CopyButton } from '@interxfi/design-system/components/copy-button/copy-button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { PageTabRail } from '../../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import {
  type PortalTabbedNavigationTab,
  TabbedNavigationGroup,
} from '../../../../../../../../../../../../components/router/router-tabbed-navigation';
import { getProxyVoteJobDetailPath } from '../../../../../../../../../../../../features/proxyvote/job/proxyvote-job-routing';
import { ProxyVoteTasksTable } from '../../../../../../../../../../../../features/proxyvote/task/proxyvote-tasks-table';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job/$jobId/_job/task')(
  {
    staticData: {
      tab: {
        group: TabbedNavigationGroup.ClearingVendorBetaNxtProxyVoteJob,
        label: 'Tasks',
        order: 1,
      },
    } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorBetaNxtProxyVoteJob>,
    loader: ({ params }) =>
      ({
        breadcrumb: buildBreadcrumb({
          id: `proxyvote-job-${params.jobId}-tasks`,
          label: 'Job',
          to: `${getProxyVoteJobDetailPath(params.jobId)}/task`,
          suffix: <CopyButton content={params.jobId} label="Copy Job ID" tooltip={{ copy: params.jobId, copied: 'Copied Job ID' }} />,
        }),
      }) satisfies AggregateBreadcrumb,
    component: ProxyVoteJobTasks,
  },
);

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorBetaNxtProxyVoteJob}
    />
  );
}

function ProxyVoteJobTasks() {
  const { jobId } = Route.useParams();

  return <ProxyVoteTasksTable HeaderActions={TableHeader} jobId={jobId} />;
}
